export function cache() {
    if (arguments.length === 1) {
        return JSON.parse(localStorage.getItem(arguments[0]) || '{}');
    } else if (arguments.length === 2) {
        localStorage.setItem(arguments[0], JSON.stringify(arguments[1]));
    }
}

export function remove(key) {
    return localStorage.removeItem(key)
}

export function setUserInfo(user) {
    cache('userInfo', user)
}

export function getUserInfo() {
    return cache('userInfo')
}

export function removeUserInfo() {
    return localStorage.removeItem('userInfo')
}

export function getData(key) {
    return localStorage.getItem(key)
}

export function setEntrance(key, entrance) {
    return localStorage.setItem(key, entrance)
}

export function getCallbackData() {
    return localStorage.getItem('callbackData')
}

export function setCallbackData(callbackDataStr) {
    return localStorage.setItem('callbackData', callbackDataStr)
}

export function getToken() {
    return localStorage.getItem('token')
}

export function setToken(token) {
    return localStorage.setItem('token', token)
}

export function removeToken() {
    return localStorage.removeItem('token')
}


export function setEnum(enums) {
    cache('enums', enums)
}

export function getEnumItemMap(enumName) {
    var _enum = cache('enums') [enumName]
    var map = {};
    for (var i in _enum) {
        map[_enum[i].name] = _enum[i].label;
    }
    return map
}


